<template>
    <div class="download-box">
        <el-row class="download-bg">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>资料下载</el-breadcrumb-item>
            </el-breadcrumb>
        </el-row>
        <el-row class="download-box-list">
            <el-col :span="16">
                <template>
                    <el-tabs class="school-detail-nav" @tab-click="changeTabHandler">
                        <el-tab-pane :label="item.title" v-for="(item,index) in tabList" :key="index">
                            <div class="province-list" v-if="index != '3'">
                                <div class="title-box">科目：</div>
                                <div class="province-name">
                                    <a v-for="(item,index) in typeList1" :class="activeTag1 == index?'active-tag':''" :key="index" @click="changeTypeHandler1(index,item)">{{item.dic_value}}</a>
                                </div>
                            </div>
                            <div class="province-list" v-if="index != '3'">
                                <div class="title-box">年份：</div>
                                <div class="province-name">
                                    <a v-for="(item,index) in typeList2" :class="activeTag2 == index?'active-tag':''" :key="index" @click="changeTypeHandler2(index,item)">{{item.dic_value}}</a>
                                </div>
                            </div>
                            <el-row style="margin-top: 16px;min-height: 300px">
                                <el-row v-if="downloadStatus == '1'">
                                    <el-col v-for="index1 in 8" :key="index1">
                                        <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="103" width="750">
                                            <rect x="0" y="0" width="700" height="93" />
                                        </ContentLoader>
                                    </el-col>
                                </el-row>
                                <div class="no-data-box" v-else-if="downloadStatus == '2'">
                                    <img src="../../assets/images/null.png" alt="没有数据">
                                    <p>暂无数据</p>
                                </div>
                                <el-row  v-else-if="downloadStatus == '3'">
                                    <el-row class="download-content-list" v-for="(item,index) in downList" :key="index">
                                        <el-col :span="3">
                                            <div class="download-subject" :style="{background:bgColorList[item.findIndex],color:colorList[item.findIndex]}" v-if="item.type != '3'">{{item.subject}}</div>
                                            <div class="download-subject download-subject-diff" v-else></div>
                                        </el-col>
                                        <el-col :span="16">
                                            <div class="download-title">{{item.name}}</div>
                                            <div class="download-count">已下载{{item.download_num}}次</div>
                                        </el-col>
                                        <el-col :span="5">
                                            <div class="download-btn" @click="downLoadUrlHandler(item.id)">
                                                <img src="../../assets/images/download.png">
                                                <span>下载</span>
                                            </div>
                                        </el-col>
                                    </el-row>
                                    <el-pagination
                                        background
                                        layout="prev, pager, next, jumper"
                                        :total="totalData" :page-size="10" @current-change="getDownloadListHandler" :current-page.sync="currentPage" v-if="downloadStatus == '3'">
                                    </el-pagination>
                                </el-row>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-col>
            <el-col :span="8" style="margin-top:80px;padding-left: 10px">
                <News class="news-right"></News>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getDownloadList,download } from '@/api/video'
import { ContentLoader } from 'vue-content-loader'
export default {
    components: {
        ContentLoader
    },
    data() {
        return {
            tabList: [
                {'id':0,title:'模拟试题'},
                {'id':1,title:'高考真题'}, 
                {'id':2,title:'高考数据下载'}, 
            ],
            typeList1: [
                {dic_value: '全部'},
                {dic_value: '语文'},
                {dic_value: '数学'},
                {dic_value: '英语'},
                {dic_value: '物理'},
                {dic_value: '化学'},
                {dic_value: '生物'},
                {dic_value: '政治'},
                {dic_value: '历史'},
                {dic_value: '地理'},
                {dic_value: '文综'},
                {dic_value: '理综'},
            ],
            typeList2: [
                {dic_value: '全部'},
                // {dic_value: '2022'},
                // {dic_value: '2021'},
                // {dic_value: '2020'},
                // {dic_value: '2019'},
                // {dic_value: '2018'},
                // {dic_value: '2017'},
                // {dic_value: '2016'},
                // {dic_value: '2015'},
                // {dic_value: '2014'},
                // {dic_value: '2013'},
            ],
            bgColorList: ['#ffd9c9','#fff0dc','#d4f2da','#def1ff','#dde5ff','#f1e1ff','#ffe1f5','#ffe4ed','#ffe7e7','#e4f0d3','#dee8ff'],
            colorList: ['#ff6524','#ff9324','#0cc740','#24a4ff','#2454ff','#9524ff','#ff24b5','#ff246f','#ff2424','#66b519','#4075e9'],
            activeTag1: 0,
            activeTag2: 0,
            totalData: 100,
            currentPage: 1,
            downList: [],
            activeType: 1,
            activeSubject: '',
            activeYear: '',
            activeBefore: '',
            downloadStatus: '1',
        };
    },

    mounted() {
        this.getFullYearList();
        this.getDownloadListHandler();
    },

    methods: {
        getFullYearList() {
            let year = (new Date()).getFullYear();
            let typeList2 = this.typeList2;
            for(let i = 0;i < 10; i++) {
                let obj = {};
                obj.dic_value = year - i;
                if(obj.dic_value == '2017') {
                    break
                }
                typeList2.push(obj)
            }
            typeList2.push({dic_value: '更早'})
        },
        getDownloadListHandler() {
            this.downloadStatus = '1';
            getDownloadList(this.activeType,this.activeSubject,this.activeYear,this.activeBefore,this.currentPage).then(res => {
                if(res.data.count == 0) {
                    this.downloadStatus = '2';
                    return
                }
                this.downloadStatus = '3';
                res.data.list.data.map((el,index) => {
                    let findIndex = this.typeList1.findIndex(function(item){
                        return item.dic_value == el.subject; 
                    })
                    el.findIndex = findIndex;
                })
                this.downList = res.data.list.data;
                this.totalData = res.data.list.total;
            })
        },
        changeTabHandler(e) {
            this.currentPage = 1;
            this.activeTag1 = 0;
            this.activeTag2 = 0;
            this.activeYear = '';
            this.activeBefore = '';
            this.activeSubject = '';
            this.downloadStatus = '1';
            this.activeType = parseInt(e.index) + 1;
            this.getDownloadListHandler()
        },
        downLoadUrlHandler(id) {
            download(id).then(res => {
                window.open(process.env.VUE_APP_FILE_API  + res.data.path);
            });
        },
        changeTypeHandler1(index,item) {
            this.activeTag1 = index;
            this.downloadStatus = '1';
            if(item.dic_value == '全部') {
                this.activeSubject = '';
            } else {
                this.activeSubject = item.dic_value;
            }
            this.getDownloadListHandler()
        },
        changeTypeHandler2(index,item) {
            this.activeTag2 = index;
            this.downloadStatus = '1';
            if(item.dic_value == '全部') {
                this.activeYear = '';
                this.activeBefore = '';
            } else if (item.dic_value == '更早') {
                this.activeYear = '';
                let year = this.typeList2[this.typeList2.length -2].dic_value; 
                this.activeBefore = year-1;
            } else {
                this.activeYear = item.dic_value;
                this.activeBefore = '';
            }
            this.getDownloadListHandler()
        }
    },
};
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    .download-bg {
        background: url('../../assets/images/ziliao.jpg') no-repeat;
        width: 100%;
        height: 132px;
        background-size: cover;
        background-position: center;
        background-origin: border-box;
        position: relative;
    }
    .download-box-list {
        @include gwidth;
        margin-top:-46px;
        .province-list {
            @include gflex;
            font-size: 0;
            align-items: flex-start;
            justify-content: space-between;
            margin-bottom: 6px;
            .title-box {
                width: 54px;
                font-size: 14px;
                text-align: left;
                color: #909399;
                margin-top: 3px;
            }
            a {
                display: inline-block;
                font-size: 14px;
                color: #5e6166;
                cursor: pointer;
                text-align: center;
                padding: 3px 5px;
                margin-bottom: 10px;
            }
            a:hover {
                color: $common-color;
            }
            a:not(:nth-child(13n)) {
                margin-right: 12px;
            }
            .active-tag {
                color: #ffffff!important;
                background: $common-color;
                border-radius: 4px;
            }
            .province-name {
                @include gflex;
                width: calc(100% - 4px);
                justify-content: flex-start;
                flex-wrap: wrap;
            }
        }
        .download-content-list {
            width: 736px;
            height: 96px;
            background: #f5f7fa;
            border-radius: 8px;
            padding: 16px;
            margin-bottom: 10px;
            .el-col-3 {
                width: 11.5%;
            }
            .download-subject {
                width: 64px;
                height: 64px;
                background: #ffd9c9;
                border-radius: 16px;
                text-align: center;
                line-height: 64px;
                font-size: 20px;
                font-weight: 600;
                color: $common-color;
            }
            .download-subject-diff {
                background: url('../../assets/images/download-icon.png') no-repeat;
            }
            .download-title {
                font-weight: 600;
                font-size: 18px;
                color: #332e2c;
                @include gnowrap;
            }
            .download-count {
                color: #999390;
                font-size: 14px;
                font-weight: 400;
                margin-top: 18px;
            }
            .download-btn {
                float: right;
                width: 60px;
                height: 30px;
                border: 1px solid $common-color;
                border-radius: 4px;
                font-weight: 400;
                color: $common-color;
                font-size: 14px;
                text-align: center;
                line-height: 30px;
                margin-top: 16px;
                cursor: pointer;
                img {
                    width: 12px;
                    height: 12px;
                    margin-right: 4px;
                }
            }
        }
    }
    .news-right {
        box-shadow: none;
        background: #ffffff;
        border: 1px solid #f5f7fa;
        border-radius: 10px;
    }
    .no-data-box {
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        img {
            width: 110px;
            height: 110px;
        }
        p {
            font-size: 16px;
            text-align: center;
            color: #abaeb3;
            margin-left: -14px;
        }
    }
</style>